import { SECOND } from "@shared/constants"

/** 남은 시간(ms)을 MM:SS 로 표기한다. 음수는 00:00 으로 본다 */
const toMMSS = (remainingTime: number) => {
  const totalSeconds = Math.max(0, Math.ceil(remainingTime / SECOND))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0",
  )}`
}

export default toMMSS
